import axios from "axios";

import getFormData from "@/shared/helpers/get-form-data.helper";
import { CConfigAxios } from "@/shared/models/const/config-request-api.const";

export const apiClient = axios.create(CConfigAxios);

export const getRequest = (endPoint: string, filters?: Object) => {
  return apiClient.get(`${endPoint}`, { params: filters });
};

export const postRequest = (
  endPoint: string,
  body: any,
  useFormData?: boolean
) => {
  const formBody = body;
  if (useFormData) {
    getFormData(formBody);
  }
  return apiClient.post(`${endPoint}`, formBody);
};

export const putRequest = (endPoint: string, body: any) => {
  return apiClient.post(`${endPoint}`, body);
};

export const deleteRequest = (endPoint: string, body: any) => {
  return apiClient.post(`${endPoint}`, body);
};

export const getFileRequest = (endPoint: string) => {
  return apiClient.get(`${endPoint}`, { responseType: "blob" });
};
